import {
    CATEGORY_LEVELS,
    CATEGORY_STATUSES,
} from "../constants/category.constants";

export function isRootCategory(level) {
    return level === CATEGORY_LEVELS.ROOT;
}

export function isTopCategory(level) {
    return level === CATEGORY_LEVELS.TOP;
}

export function isSubCategory(level) {
    return level === CATEGORY_LEVELS.SUB;
}

export function isPublishedCategory(status) {
    return status === CATEGORY_STATUSES.PUBLISHED;
}

export function isHiddenCategory(status) {
    return status === CATEGORY_STATUSES.HIDDEN;
}

export function isArchivedCategory(status) {
    return status === CATEGORY_STATUSES.ARCHIVED;
}

export function isCategoryAvailableForDelete(category) {
    if (
        !category?.lvl ||
        category?.productsCount === undefined ||
        category?.subCount === undefined
    ) {
        return false;
    }

    if (isRootCategory(category.lvl)) {
        return false;
    }

    if (
        (isTopCategory(category.lvl) && category.subCount > 0) ||
        (isTopCategory(category.lvl) && category.productsCount > 0)
    ) {
        return false;
    }

    if (isSubCategory(category.lvl) && category.productsCount > 0) {
        return false;
    }

    return true;
}

export function isCategoryAvailableForBulkDelete(category) {
    if (!category?.lvl || category?.productsCount === undefined) {
        return false;
    }

    return isSubCategory(category.lvl) && Number(category.productsCount) === 0;
}

export function areCategoriesAvailableForBulkDelete(categories) {
    return Array.isArray(categories)
        && categories.length > 0
        && categories.every(isCategoryAvailableForBulkDelete);
}
